const parseAPIResponse = (result) => {

    if (result.status !== 200 || !result.data) {
        return Promise.reject("Error with request.");
    }

    if (result.data.errorMessage) {
        return Promise.reject(result.data.errorMessage);
    }

    if (result.data.errors) {
        const errors = Array.isArray(result.data.errors)
            ? result.data.errors
            : [result.data.errors]

        const message = errors.join('\n');
        return Promise.reject(message);
    }

    if (!result.data) {
        return Promise.reject("No data returned");
    }

    const data = result.data || result;

    if (data.data && data.extensions) {
        return data.data;
    }

    return data;
}

export { parseAPIResponse };